export const isVisible = ({ loadingModal: { isVisible: state } }) => state;



// WEBPACK FOOTER //
// ./src/store/selectors/loadingModal.js